import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsJobRecall extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForJobRecall: "/api/v1/portal/jobs/recall-job-from-thirdparty/",
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  jobRecall(jobId) {
    return fetch(
      this.state.apiUrlForJobRecall +
      jobId,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
    }
    );
  }

  render() {
    return (
      <span> {this.state.data.thirdparty && (
        <button
          className="btn btn-lg btn-move-job-to-delivered"
          onClick={() => {
            this.jobRecall(this.state.data.id)
          }}>
          <i className="fa fa-undo" aria-hidden="true"></i>&nbsp;
          Job Recall
        </button>
      )}
      </span>
    )
  }
}